import React, { Component } from 'react';
import cachios from 'cachios';
import Axios from 'axios';
import { BASE } from "../api/api";
import { Link } from 'react-router-dom'
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import TopBar from '../topbar/topbar'
import { List } from 'react-content-loader'
import sample from '../assets/Article.png'
import htmlToText from 'html-to-text'

class InstitutionNew extends Component {
    constructor(props) {
        console.log(props, 'props')
        super(props);
        this.state = {
            imagearray: [],
            imagearray2: [],
            imagearray3: [],
            limit: 8,
            offset: this.props.match.params.sec === "banks" ? this.props.match.params.page : 0,
            offset2: this.props.match.params.sec === "company" ? this.props.match.params.page : 0,
            offset3: this.props.match.params.sec === "other" ? this.props.match.params.page : 0
        };
    }

    scroll(id) {
        document.getElementById(id).scrollIntoView({
            behavior: 'smooth'
        });
    }

    signout() {
        localStorage.removeItem('token');
        localStorage.removeItem('expirytime');
        localStorage.removeItem('expiryref');
        // window.location.href = '/'

    }


    refreshexp() {
        let s = new Date();
        s.setSeconds(s.getSeconds() + 1800);
        localStorage.setItem('expiryref', s)
    }


    checkexpiry() {
        if (localStorage.getItem('expiryref')) {
            let expref = Date.parse(localStorage.getItem('expiryref'))
            let s = new Date();
            if (s > expref) {
                this.signout()
            }
            else {
                this.refreshexp()
            }

        }
        else {
            this.signout()
        }
    }




    componentWillReceiveProps(nextProps) {
        if (localStorage.getItem('token'))
            this.checkexpiry()
        console.log(nextProps, 'props')
        if (nextProps.match.params.sec === "banks") {
            this.scroll('bank')
            this.bankcall(nextProps.match.params.page)
        }
        if (nextProps.match.params.sec === "company") {
            this.scroll('company')
            this.companycall(nextProps.match.params.page)
        }
        if (nextProps.match.params.sec === "other") {
            this.scroll('other')
            this.othercall(nextProps.match.params.page)
        }
    }
    // this.props.history.push('/financial_institution/'+section+'/' + (parseInt(offset, 10) + this.state.limit))

    handlePageClick(data, section) {
        if (this.logincheck()) {
            if (section === "banks") {
                if (data === "next" && this.state.next) {
                    this.props.history.push('/financial_institution/banks/' + (this.state.offset + this.state.limit))
                    this.setState({
                        offset: this.state.offset + this.state.limit
                    })
                }
                if (data === "prev" && this.state.prev) {
                    this.props.history.push('/financial_institution/banks/' + (this.state.offset - this.state.limit))
                    this.setState({
                        offset: this.state.offset - this.state.limit
                    })
                }
            }
            if (section === "company") {
                if (data === "next" && this.state.next2) {
                    this.props.history.push('/financial_institution/company/' + (this.state.offset2 + this.state.limit))
                    this.setState({
                        offset2: this.state.offset2 + this.state.limit
                    })
                }
                if (data === "prev" && this.state.prev2) {
                    this.props.history.push('/financial_institution/company/' + (this.state.offset2 - this.state.limit))
                    this.setState({
                        offset2: this.state.offset2 - this.state.limit
                    })
                }
            }
            if (section === "other") {
                if (data === "next" && this.state.next3) {
                    this.props.history.push('/financial_institution/other/' + (this.state.offset3 + this.state.limit))
                    this.setState({
                        offset3: this.state.offset3 + this.state.limit
                    })
                }
                if (data === "prev" && this.state.prev3) {
                    this.props.history.push('/financial_institution/other/' + (this.state.offset3 - this.state.limit))
                    this.setState({
                        offset3: this.state.offset3 - this.state.limit
                    })
                }
            }
        }
        else {
            this.props.history.push('/login?redir=/financial_institution/' + section + '/' + (parseInt(this.state.offset, 10) + this.state.limit))
        }


    }

    banknextcheck(id, type, next) {
        //to check Next page
        let nextoff = parseInt(id, 10) + this.state.limit
        Axios(BASE + 'jsonapi/node/institutions?sort=title&include=field_image&filter[titleFilter][condition][path]=field_institution_type.name&filter[titleFilter][condition][value]=' + type + '&page[limit]=' + this.state.limit + '&page[offset]=' + nextoff, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then((data) => {
                console.log(data.data, 'next', nextoff, id, this.state.limit)
                //HIDE/SHOW  NEXT button
                if (data.data.data.length === 0) {
                    this.setState({
                        [next]: false,
                    })
                }
                else {
                    this.setState({
                        [next]: true
                    })
                }
            })
    }

    othercall(id) {
        if (id <= 0) {
            this.setState({
                prev3: false,
            })
        }
        else {
            this.setState({
                prev3: true
            })
        }
        cachios.get(BASE + 'jsonapi/node/institutions?sort=title&include=field_image&filter[titleFilter][condition][path]=field_institution_type.name&filter[titleFilter][condition][value]=Other Financial Institutions in Qatar&page[limit]=' + this.state.limit + '&page[offset]=' + id, {
            ttl: 500 /* seconds */,
        })
            .then((data) => {
                console.log(data)
                this.setState({
                    other: data.data.data
                })
                let i, j;
                let imagearray = []
                for (i = 0; i < data.data.data.length; i++) {
                    if (data.data.data[i].relationships.field_image.data !== null) {
                        for (j = 0; j < data.data.included.length; j++) {
                            if (data.data.data[i].relationships.field_image.data.id === data.data.included[j].id) {
                                imagearray.push(BASE + data.data.included[j].attributes.uri.url);
                            }
                        }
                    }
                    else {
                        imagearray.push(sample)
                    }
                }
                this.setState({
                    imagearray3: imagearray
                })
                this.banknextcheck(id, 'Other Financial Institutions in Qatar', 'next3')
            })
            .catch(error => console.log(error));
    }

    companycall(id) {
        if (id <= 0) {
            this.setState({
                prev2: false,
            })
        }
        else {
            this.setState({
                prev2: true
            })
        }
        cachios.get(BASE + 'jsonapi/node/institutions?sort=title&include=field_image&filter[titleFilter][condition][path]=field_institution_type.name&filter[titleFilter][condition][value]=Islamic Insurance Companies in Qatar&page[limit]=' + this.state.limit + '&page[offset]=' + id, {
            ttl: 500 /* seconds */,
        })
            .then((data) => {
                console.log(data)
                this.setState({
                    companies: data.data.data
                })
                let i, j;
                let imagearray = []
                for (i = 0; i < data.data.data.length; i++) {
                    if (data.data.data[i].relationships.field_image.data !== null) {
                        for (j = 0; j < data.data.included.length; j++) {
                            if (data.data.data[i].relationships.field_image.data.id === data.data.included[j].id) {
                                imagearray.push(BASE + data.data.included[j].attributes.uri.url);
                            }
                        }
                    }
                    else {
                        imagearray.push(sample)
                    }
                }
                this.setState({
                    imagearray2: imagearray
                })
                this.banknextcheck(id, 'Islamic Insurance Companies in Qatar', 'next2')
            })
            .catch(error => console.log(error));
    }

    bankcall(id) {
        if (id <= 0) {
            this.setState({
                prev: false,
            })
        }
        else {
            this.setState({
                prev: true
            })
        }
        cachios.get(BASE + 'jsonapi/node/institutions?sort=title&include=field_image&filter[titleFilter][condition][path]=field_institution_type.name&filter[titleFilter][condition][value]=Islamic Banks in Qatar&page[limit]=' + this.state.limit + '&page[offset]=' + id, {
            ttl: 500 /* seconds */,
        })
            .then((data) => {
                if (localStorage.getItem('token'))
                    this.checkexpiry()
                console.log(data)
                this.setState({
                    banks: data.data.data
                })
                let i, j;
                let imagearray = []
                for (i = 0; i < data.data.data.length; i++) {
                    if (data.data.data[i].relationships.field_image.data !== null) {
                        for (j = 0; j < data.data.included.length; j++) {
                            if (data.data.data[i].relationships.field_image.data.id === data.data.included[j].id) {
                                imagearray.push(BASE + data.data.included[j].attributes.uri.url);
                            }
                        }
                    }
                    else {
                        imagearray.push(sample)
                    }
                }
                this.setState({
                    imagearray: imagearray
                })
                this.banknextcheck(id, 'Islamic Banks in Qatar', 'next')
            })
            .catch(error => console.log(error));
    }
    logincheck

    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    componentWillMount() {
        this.topFunction();
        localStorage.removeItem('inst_ret');
        if (this.logincheck()) {
            this.bankcall(this.state.offset)
            this.companycall(this.state.offset2)
            this.othercall(this.state.offset3)
        }
        else {
            this.bankcall(0)
            this.companycall(0)
            this.othercall(0)
            this.setState({
                offset: 0,
                offset2: 0,
                offset3: 0
            })
            this.props.history.push('/financial_institution')
        }
    }

    getlink(link) {
        if (this.logincheck()) {

            return link
        }
        else
            return '/login?redir=' + link
    }

    logincheck() {
        let login = localStorage.getItem('token');
        if (login && login != null) {
            return true
        }
        else
            return false
    }

    render() {
        return (
            <div className='formrea yourwork sub_work'>
                <Header />
                <div className='container'>
                    <div className='listings'>
                        <div className='top-contents'>
                            <div className="crumbs "><Link to='/'>Home</Link> / <Link to='/financial_institution'>Financial Institutions in Qatar</Link></div>
                           
                        </div>
                        <div className="listing">
                            <div className="page-title">
                                <div className="title-wrapper">
                                    <div className="">
                                        <h1 className="heading">Financial Institutions in Qatar</h1>
                                    </div>
                                </div>
                            </div>

                            <div className="main-content fininst">
                                <div className="">
                                    <div className="row">
                                        <div className="region region-content">
                                            <div className="listings finlist">
                                                {this.state.banks ? this.state.banks.length != 0 ?
                                                    <h2 id="bank" className='heading2'>Islamic Banks in Qatar</h2> : '' : ''}
                                                {this.state.banks ? this.state.banks.length != 0 && this.state.imagearray.length !== 0 ?
                                                    <div className="mission">
                                                        {this.state.banks.map((inst, index) => {
                                                            return (
                                                                <div className="findiv">
                                                                    <div className="title">
                                                                        <span className="field-content bookdiv">
                                                                            <div>
                                                                                <Link to={{ pathname: '/financial_institution/Islamic Banks in Qatar/desc/' + `${inst.attributes.drupal_internal__nid}` }}>
                                                                                    <img src={this.state.imagearray[index]} />
                                                                                </Link>
                                                                            </div>
                                                                            <div className="bookdetails">
                                                                                <Link to={{ pathname: '/financial_institution/Islamic Banks in Qatar/desc/' + `${inst.attributes.drupal_internal__nid}` }}>{inst.attributes.title}</Link>
                                                                                {inst.attributes.body ? <div>
                                                                                    {htmlToText.fromString(inst.attributes.body.processed, {
                                                                                        wordwrap: 130
                                                                                    }).length > 120 ? htmlToText.fromString(inst.attributes.body.processed, {
                                                                                        wordwrap: 130
                                                                                    }).substring(0, 120) + '...' : htmlToText.fromString(inst.attributes.body.processed, {
                                                                                        wordwrap: 130
                                                                                    })}
                                                                                </div> : ''}
                                                                            </div>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                        }
                                                        {this.state.banks ? this.state.prev || this.state.next ?

                                                            <ul className="pagination">
                                                                <li onClick={() => this.handlePageClick('prev', 'banks')} className="previous disabled">
                                                                    <a style={{ color: this.state.prev ? '#165E84 ' : '', fontWeight: this.state.prev ? '500' : '', cursor: this.state.prev ? '' : 'not-allowed' }} tabindex="0" role="button" className="prev" aria-disabled="true">Previous</a></li>
                                                                <li onClick={() => this.handlePageClick('next', 'banks')} className="next"><a style={{ color: this.state.next ? '#165E84 ' : '', fontWeight: this.state.next ? '500' : '', cursor: this.state.next ? '' : 'not-allowed' }} tabindex="0" role="button" aria-disabled="false">Next</a></li>

                                                            </ul>

                                                            : '' : ''}
                                                    </div>
                                                    : '' : <List />
                                                }

                                                {this.state.companies ? this.state.companies.length != 0 ?
                                                    <h2 id="company" className='heading2'>Islamic Insurance Companies in Qatar</h2> : '' : ''}
                                                {this.state.companies ? this.state.companies.length != 0 && this.state.imagearray2.length !== 0 ?
                                                    <div className="mission">
                                                        {this.state.companies.map((inst, index) => {
                                                            return (
                                                                <div className="findiv">
                                                                    <div className="title">
                                                                        <span className="field-content bookdiv">
                                                                            <div>
                                                                                <Link to={{ pathname: '/financial_institution/Islamic Insurance Companies in Qatar/desc/' + `${inst.attributes.drupal_internal__nid}` }}>
                                                                                    <img src={this.state.imagearray2[index]} />
                                                                                </Link>
                                                                            </div>
                                                                            <div className="bookdetails">
                                                                                <Link to={{ pathname: '/financial_institution/Islamic Insurance Companies in Qatar/desc/' + `${inst.attributes.drupal_internal__nid}` }}>{inst.attributes.title}</Link>
                                                                                {inst.attributes.body ? <div>
                                                                                    {htmlToText.fromString(inst.attributes.body.processed, {
                                                                                        wordwrap: 130
                                                                                    }).length > 120 ? htmlToText.fromString(inst.attributes.body.processed, {
                                                                                        wordwrap: 130
                                                                                    }).substring(0, 120) + '...' : htmlToText.fromString(inst.attributes.body.processed, {
                                                                                        wordwrap: 130
                                                                                    })}
                                                                                </div> : ''}
                                                                            </div>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                        }
                                                        {this.state.companies ? this.state.prev2 || this.state.next2 ?

                                                            <ul className="pagination">
                                                                <li onClick={() => this.handlePageClick('prev', 'company')} className="previous disabled">
                                                                    <a style={{ color: this.state.prev2 ? '#165E84 ' : '', fontWeight: this.state.prev2 ? '500' : '', cursor: this.state.prev2 ? '' : 'not-allowed' }} tabindex="0" role="button" className="prev" aria-disabled="true">Previous</a></li>
                                                                <li onClick={() => this.handlePageClick('next', 'company')} className="next"><a style={{ color: this.state.next2 ? '#165E84 ' : '', fontWeight: this.state.next2 ? '500' : '', cursor: this.state.next2 ? '' : 'not-allowed' }} tabindex="0" role="button" aria-disabled="false">Next</a></li>

                                                            </ul>

                                                            : '' : ''}
                                                    </div>
                                                    : '' : <List />
                                                }



                                                {this.state.other ? this.state.other.length != 0 ?
                                                    <h2 id="other" className='heading'>Other Financial Institutions in Qatar</h2> : '' : ''}
                                                {this.state.other ? this.state.other.length != 0 && this.state.imagearray3.length !== 0 ?
                                                    <div className="mission">
                                                        {this.state.other.map((inst, index) => {
                                                            return (
                                                                <div className="findiv">
                                                                    <div className="title">
                                                                        <span className="field-content bookdiv">
                                                                            <div>
                                                                                <Link to={{ pathname: '/financial_institution/Other Financial Institutions in Qatar/desc/' + `${inst.attributes.drupal_internal__nid}` }}>
                                                                                    <img src={this.state.imagearray3[index]} />
                                                                                </Link>
                                                                            </div>
                                                                            <div className="bookdetails">
                                                                                <Link to={{ pathname: '/financial_institution/Other Financial Institutions in Qatar/desc/' + `${inst.attributes.drupal_internal__nid}` }}>{inst.attributes.title}</Link>
                                                                                {inst.attributes.body ? <div>
                                                                                    {htmlToText.fromString(inst.attributes.body.processed, {
                                                                                        wordwrap: 130
                                                                                    }).length > 120 ? htmlToText.fromString(inst.attributes.body.processed, {
                                                                                        wordwrap: 130
                                                                                    }).substring(0, 120) + '...' : htmlToText.fromString(inst.attributes.body.processed, {
                                                                                        wordwrap: 130
                                                                                    })}
                                                                                </div> : ''}
                                                                            </div>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                        }
                                                        {this.state.other ? this.state.prev3 || this.state.next3 ?

                                                            <ul className="pagination">
                                                                <li onClick={() => { this.handlePageClick('prev', 'other') }} className="previous disabled">
                                                                    <a style={{ color: this.state.prev3 ? '#165E84 ' : '', fontWeight: this.state.prev3 ? '500' : '', cursor: this.state.prev3 ? '' : 'not-allowed' }} tabindex="0" role="button" className="prev" aria-disabled="true">Previous</a></li>
                                                                <li onClick={() => this.handlePageClick('next', 'other')} className="next"><a style={{ color: this.state.next3 ? '#165E84 ' : '', fontWeight: this.state.next3 ? '500' : '', cursor: this.state.next3 ? '' : 'not-allowed' }} tabindex="0" role="button" aria-disabled="false">Next</a></li>

                                                            </ul>

                                                            : '' : ''}
                                                    </div>
                                                    : '' : <List />
                                                } </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>


        )

    }

}

export default InstitutionNew;